import React from 'react';
import { useApp } from '../../context/AppContext';
import { CheckCircle, AlertCircle, Info } from 'lucide-react';

export default function Toast() {
  const { toast } = useApp();
  if (!toast) return null;
  const icons = { success: <CheckCircle size={16} color="var(--accent)" />, warning: <AlertCircle size={16} color="var(--amber)" />, error: <AlertCircle size={16} color="var(--red)" /> };
  const colors = { success: 'var(--accent)', warning: 'var(--amber)', error: 'var(--red)' };
  return (
    <div className="toast" style={{ borderLeft: `3px solid ${colors[toast.type] || colors.success}` }}>
      {icons[toast.type] || icons.success}
      <span style={{ fontSize: 13 }}>{toast.msg}</span>
    </div>
  );
}
